<div id="app" *ngIf="translator.translationsReady">

	<a href="{{routeSkipNav}}" target="_self" class="visually-hidden focusable skip-link">
		Skip to main content
	</a>	

	<div class="container-fluid fmcsa p-0">
		<!--[if lt IE 9]>
            <script src="https://html5shim.googlecode.com/svn/trunk/html5.js"></script>
            <script src="/scripts/js/respond.js"></script>
		<![endif]-->

		<!-- FMCSCA and PSP header -->
		<header>
			<section id="us-banner">
				<h2 class="sr-only">USA Banner</h2>
				<div class="container">
					<div class="row">
					<div class="col">
						<header id="officialGovHeading">
							<div class="row d-flex align-items-center" data-bs-toggle="collapse" 
                                   href="#officialGovDetails" role="region" aria-controls="officialGovDetails" aria-expanded="false">
								<div class="col-sm d-flex">
									<div>
									<img 
                                                  id="us-flag" 
                                                  class="me-2" 
                                                  src="assets/content/css/images/us_flag_small.svg" 
                                                  alt="U.S. flag" 
                                                  name="official-government" 
                                                  aria-hidden="true">
									</div>
									<div>
									<p class="m-0">An official website of the United States government
										<button 
                                                       type="button" 
                                                       class="btn-link border-0 ms-1 fake-hyperlink text-nowrap pe-pointer" 
                                                       id="officialGovExpand" 
                                                       (click)="collapse.toggle()" 
                                                       [attr.aria-expanded]="!isCollapsed" 
                                                       variant="primary" 
                                                       name="here-is-how-you-know" 
                                                       aria-controls="officialGovDetails"
                                                       title="Here's how you know" 
                                                  >
											Here's how you know<i class="fas fa-chevron-down size-9 ms-1" name="heres-how-you-know" 
                                                       id="heres-how-you-know" title="Here's how you know" aria-hidden="true"></i>
										</button>
									</p>
									</div>
								</div>
							</div>
						</header>
						<div class="container" >
							<div id="officialGovDetails" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="row" aria-labelledby="officialGovHeading" data-parent="#officialGovHeading">
								<div class="us-width-one-half col-sm d-flex">
									<div class="us-media_block-icon">
									<img
										src="assets/content/css/images/gov-bldg-icon.svg"
										class="us-banner-icon" 
										name="the-gov-means-it-is-official"
                                                  id="the-gov-means-it-is-official"
										alt="Official US Government Icon"
										aria-hidden="true"
									/>
									</div>
									<div class="us-media_block-body">
									<p><span class="fw-bold">Official websites use .gov</span><br>A <strong>.gov</strong> website belongs to an official government organization in the United States.</p>
									</div>
								</div>
								<div class="us-width-one-half col-sm d-flex">
									<div class="us-media_block-icon">
									<img
										src="assets/content/css/images/green-lock-icon.svg"
										class="us-banner-icon" 
										name="lock-icon2"
                                                  id="lock-icon2"
										alt="Secure Site Icon"
										aria-hidden="true"
									/>									
									</div>
									<div class="us-media_block-body">
									<p>
										<span class="fw-bold">Secure .gov websites use HTTPS</span><br>
										A <span class="fw-bold">lock</span> ( 
										<i class="fas fa-lock" name="lock-icon1" id="lock-icon1" title="Lock" aria-hidden="true"></i> ) or <span class="fw-bold">https://</span> means you’ve safely connected to the .gov website. Share sensitive information only on official, secure websites.
									</p>
									</div>
								</div>
							</div>
						</div>
					</div>
					</div>
				</div>
			</section>
			<section class="text-white bg-brand-dark" id="dot-banner">
				<div class="container d-flex justify-content-between align-items-center">
					<div class="d-flex align-items-center mw-72">
					<img id="dot-logo" 
                              name="dot-logo" 
                              class="me-2" src="assets/content/css/images/usdot-logo.png" 
                              title="United States Department of Transportation" 
                              alt="United States Department of Transportation">
					<a 
						href="http://www.dot.gov/" 
						target="_blank" 
						rel="noopener noreferrer" 
						aria-label="United States Department of Transportation" 
						name="United-States-Department-of-Transportation" 
                              id="United-States-Department-of-Transportation" 
						class="d-inline-block text-truncate" 
					>United States Department of Transportation</a>
					</div>
					<div class="d-flex flex-row justify-content-between ms-lg-auto">
					<div
						class="lan-search"
						*ngIf="spanish || french"
					>
						<div class="dropdown" ngbDropdown>
							<button 
                                        class="btn btn-sm dropdown-toggle lang-dropdown text-white m-0 p-0"
                                        ngbDropdownToggle 
                                        type="button" 
                                        id="selectLanguageBtn" 
                                        name="selectLanguageBtn" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false">
								{{selectedLang}}
							</button>
							<ul ngbDropdownMenu  class="dropdown-menu dropdown-menu-end lang-dropdown" aria-labelledby="selectLanguageBtn">
								<li>
									<a 
									class="dropdown-item lang-item lang-item-first " 
									(click)="setLanguage('EN')" 
									[ngClass]="{'active': this.selectLang === 'EN'}"
									tabindex="0"
                                             name="US English"
                                             id="US English"
									>US English
									</a>
								</li>
								<li *ngIf="spanish">
									<a 
									class="dropdown-item lang-item " 
									(click)="setLanguage('ES')" 
									[ngClass]="{'active': this.selectLang === 'ES'}"
									tabindex="0"
                                             name="Spanish"
                                             id="Spanish"
									>Español
									</a>
								</li>
								<li *ngIf="french">
									<a 
									class="dropdown-item lang-item " 							
									(click)="setLanguage('FR')" 
									[ngClass]="{'active': this.selectLang === 'FR'}"
									tabindex="0"
                                             name="French"
                                             id="French"
									>Français
									</a>
								</li>
							</ul>
						</div>									
					</div>                    
					</div>
				</div>
			</section>  
			<section class="text-white bg-brand fmcsa-banner">
				<div class="container d-flex flex-column justify-content-between flex-md-row">
				<div class="d-flex flex-column justify-content-between flex-md-row w-100">
				<div class="d-flex align-items-center">
					<a 
                              href="https://www.fmcsa.dot.gov/" 
                              target="_blank" 
                              rel="noopener noreferrer" 
                              class="d-inline-block text-truncate"
                              id="FMCSA-Link"
                              name="FMCSA-Link"
					>
					<img 
                              id="fmcsa-logo" 
                              name="fmcsa-logo" 
                              class="me-2 fmcsa-logo" 
                              src="assets/content/css/images/fmcsa-logo.png" 
                              aria-hidden="true">								
					<span class="sr-only"><strong>FMCSA</strong> - Federal Motor Carrier Safety Administration</span>
					</a>
				</div>
				<div class="d-flex flex-row justify-content-between ms-lg-auto">
					<div class="flex-grow-1 ms-auto mt-2 mt-md-0">
					<div class="form-group m-0">
						<label 
                                   class="sr-only" 
                                   for="search-term"
                                   [innerHTML]="'fmcsa-search' | translator:'base'"
						>Search</label>
						<div class="input-group">
						<input 
                                   [attr.aria-label]="'fmcsa-search' | translator:'base'" 
                                   aria-describedby="gov-search"
                                   type="text"
                                   (keydown)="searchGov($event)"
                                   class="form-control form-control-sm border-0 rounded-0 "
                                   [title]="'fmcsa-search' | translator:'base'"
                                   [placeholder]="'fmcsa-search' | translator:'base'"
                                   [attr.aria-placeholder]="'fmcsa-search' | translator:'base'"
                                   [(ngModel)]="searchPSPText"
                                   name="Search"
                                   id="search-term"
						>							
						<div class="input-group-append">
						<button 
							type="button" 
							id="gov-search"
                                   name="gov-search"
							(click)="searchGov(true)"
							class="btn btn-link btn-search btn-sm bg-white d-flex justify-content-center align-items-center text-brand h-100 py-1 px-2"
							[title]="'fmcsa-search' | translator:'base'"
						>
							<i class="fa fa-search search-button" width="0.875rem" height="0.875rem"></i>
							<span class="sr-only">Search</span>
						</button>
						</div>
						</div>
					</div>                                                                    
					</div>				
				</div>
				</div>
				</div>
			</section>
			<nav class="navbar navbar-dark navbar-expand-lg bg-brand psp-navbar" id="psp-navbar" aria-label="PSP main navigation">
				<div class="container">
				<a
                         class="navbar-brand d-flex text-white align-items-center pe-0 me-0"
                         [routerLink]="homelink"
                         id="linkHome"
                         name="linkHome"
				>
				<img
					class="me-2"
					src="assets/content/css/images/psp-icon/psp-old-logo.png"
					width="48"
					height="48"
					alt="Pre-employment Screening Program Logo"
                         id="PSP-logo"
                         name="PSP-logo"
				/>
				<!-- Do not translate our heading and sub-heading. -->
				<span>Pre-Employment Screening Program</span>
				</a>
				<button
                         class="navbar-toggler no-focus-outline text-white w-100"
                         type="button"
                         (click)="isMenuCollapsed = !isMenuCollapsed"
                         [ariaLabel]="'ToggleNav' | translator: 'base'"
                         id="toggle-nav-button"
                         name="toggle-nav-button"
				>
				<i class="fas fa-bars text-white" name="alert" id="alert" aria-hidden="true"></i>
				<span class="ms-2" style="position:relative;top:-1px;">
					<span class="sr-only" [innerHtml]="'ToggleNav1' | translator:'base'">Toggle </span>
                              <span [innerHtml]="'ToggleNav2' | translator:'base'"> Navigation</span>
				</span>
				</button>
				<div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse multi-collapse" id="navcol">
				<ul class="navbar-nav ms-auto">
					<li class="nav-item">
					<a
						[routerLink]="'/signup/welcome'"
						class="nav-link"
						[routerLinkActive]="'active'"
						(click)="scrollToTop()"
						[innerHtml]="'Enroll' | translator:'base'"
						[ariaLabel]="'Enroll' | translator:'base'"
						id="enroll"
						name="enroll"
					>
						Enroll
					</a>
					</li>
					<li class="nav-item">
					<a
						[routerLink]="'/drivers'"
						class="nav-link"
						routerLinkActive="active"
						(click)="scrollToTop()"
						[innerHtml]="'Drivers' | translator:'base'"
						[ariaLabel]="'Drivers' | translator:'base'"
                              id="drivers-nav"
                              name="drivers-nav"
					>
						Drivers
					</a>
					</li>
					<li class="nav-item">
					<a
						[routerLink]="'/veterans'"
						class="nav-link"
						[routerLinkActive]="'active'"
						(click)="scrollToTop()"
						[innerHtml]="'Veterans' | translator:'base'"
						[ariaLabel]="'Veterans' | translator:'base'"
                              id="veterans-nav"
                              name="veterans-nav"
					>
						Veterans
					</a>
					</li>
					<li class="nav-item">
						<a
							[routerLink]="'/women-drivers'"
							class="nav-link"
							[routerLinkActive]="'active'"
							(click)="scrollToTop()"
                                   [innerHtml]="'WomenNav' | translator:'base'"
						     [ariaLabel]="'WomenNav' | translator:'base'"
						>
							Women Drivers
						</a>
						</li>
					<li class="nav-item">
					<a
						[routerLink]="'/FAQ'"
						class="nav-link"
						[routerLinkActive]="'active'"
						[innerHtml]="'FAQs' | translator:'base'"
						[ariaLabel]="'FAQs' | translator:'base'"
                              id="faq-nav"
                              name="faq-nav"
					>
						FAQs
					</a>
					</li>
					<li class="nav-item">
					<a
						[routerLink]="'/customerSupport'"
						class="nav-link"
						[routerLinkActive]="'active'"
						[innerHtml]="'Contact' | translator:'base'"
						[ariaLabel]="'Contact' | translator:'base'"
                              id="contact-us-nav"
                              name="contact-us-nav"
					>
						Contact
					</a>
					</li>
				</ul>
				</div>
				</div>
			</nav>
			<nav 
				id="psp-navbar-login" 
                    name="psp-navbar-login" 
                    class="navbar navbar-expand-lg bg-white m-0" 
				aria-label="PSP application navigation" 
				*ngIf="(routeNavbar !== 'home' && routeNavbar !== '/home' && routeNavbar !== 'home#maincontent' && routeNavbar !== '/home#maincontent' && routeNavbar !== '/' && routeNavbar !== '/public' && routeNavbar !== '/Public')" 
			>
				<div class="container">
					<app-login-chat-nav [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse multi-collapse" id="navbarSupportedContent" name="navbarSupportedContent" />
				</div>
			</nav>
			<noscript>
				<div class="alert alert-danger text-center">
				<i class="fas fa-exclamation"
					name="alert-javascript"
                         id="alert-javascript"
					[title]="'Alert' | translator:'base'"
					aria-hidden="true"
				></i>
				<span class="pl-2" [innerHtml]="'JavascriptAlert' | translator:'base'">
					Javascript must be enabled to use all of the functionality of this site.
				</span>
				</div>
			</noscript>   
		</header>
	</div>
	
	<main id="main-content" class="default-content">
		<router-outlet></router-outlet>
	</main>
	<footer class="text-white bg-brand-dark fmcsa-footer" id="fmcsa-footer">
		<div class="container">
			<div class="row">
				<div class="col-12 col-sm-6 mb-4 mb-sm-0">
					<address class="mb-0">
						<p>U.S. DEPARTMENT OF TRANSPORTATION</p>
						<p><strong>Federal Motor Carrier Safety Administration</strong></p>
						<p>1200 NEW JERSEY AVENUE, SE</p>
						<p>WASHINGTON, DC 20590</p>
						<p>1-800-832-5660</p>
					</address>
				</div>
				<div class="col-12 col-sm-6 mb-4 mb-sm-0 d-flex justify-content-sm-end">
					<div>
						<p>
							<a class="btn btn-primary subscribe-button"
								href="https://public.govdelivery.com/accounts/USDOTFMCSA/subscriber/new"
								target="_blank" rel="noopener noreferrer"
								id="Subscribe-to-FMCSA-email-updates-nav"
                                        name="Subscribe-to-FMCSA-email-updates-nav"
                                        role="link"
                                        aria-label="Subscribe to Email Updates link"
                                   >
								<span>Subscribe To Email Updates</span>
							</a>
						</p>
						<ul class="footer-social d-flex justify-content-between">
							<li>
								<a href="https://www.facebook.com/FMCSA/" target="_blank"
									rel="noopener noreferrer" 
                                             name="FMCSA-Facebook-nav"
                                             id="FMCSA-Facebook-nav"
									aria-label="FMCSA on Facebook"
                                             role="link"
                                        >
									<span class="fontawesome-icon-inline">
										<i class="fab fa-facebook" title="Facebook" aria-hidden="true"></i>
									</span>
									<span class="sr-only">FMCSA on Facebook</span>
								</a>
							</li>
							<li>
								<a href="https://twitter.com/FMCSA" 
                                             target="_blank" 
                                             rel="noopener noreferrer"
									name="FMCSA-Twitter-nav"
                                             id="FMCSA-Twitter-nav" 
                                             aria-label="FMCSA on Twitter"
                                             role="link"
									title="Twitter"
                                        >
									<svg xmlns="http://www.w3.org/2000/svg" title="FMCSA on Twitter" width="16" height="16" fill="currentColor" class="fab bi bi-twitter-x" viewBox="0 0 16 16" style="padding: 8px;">
										<path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
									</svg>
									<span class="sr-only">FMCSA on Twitter</span>
								</a>
							</li>
							<li>
								<a href="https://www.instagram.com/dot_fmcsa/" 
                                             target="_blank"
									rel="noopener noreferrer" 
                                             name="FMCSA-Instagram-nav"
                                             id="FMCSA-Instagram-nav"
									aria-label="FMCSA on Instagram"
                                             role="link"
                                        >
									<span class="fontawesome-icon-inline">
										<i class="fab fa-instagram" title="Instagram" aria-hidden="true"></i>
									</span>
									<span class="sr-only">FMCSA on Instagram</span>
								</a>
							</li>
							<li>
								<a href="https://www.youtube.com/user/usdotgov" 
                                             target="_blank"
									rel="noopener noreferrer" 
                                             name="FMCSA-YouTube-nav"
                                             id="FMCSA-YouTube-nav"
									aria-label="FMCSA on YouTube"
                                             role="link"
                                        >
									<span class="fontawesome-icon-inline">
										<i class="fab fa-youtube" aria-hidden="true"
											title="FMCSA YouTube"></i>
									</span>
									<span class="sr-only">FMCSA on YouTube</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 col-sm-3 mb-5 mb-sm-0">
					<h2 class="text-white h6 fw-bold">About</h2>
					<ul class="nav flex-column">
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/mission/about-us" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="about-FMCSA-nav" 
                                        id="about-FMCSA-nav" 
                                        class="nav-link"
                                        aria-label="About FMCSA link"
                                        role="link"
                                   >About FMCSA</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/regulations" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="About-FMCSA-Regulations-nav"
                                        id="About-FMCSA-Regulations-nav"
								class="nav-link"
                                        role="link"
                                   >Regulations</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/safety" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
								name="About-FMCSA-Safety-nav"
                                        id="About-FMCSA-Safety-nav" 
                                        aria-label="About FMCSA Safety link"
                                        role="link"
                                        class="nav-link"
                                   >Safety</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/safety/analysis-research-technology"
								target="_blank" 
                                        rel="noopener noreferrer" 
                                        name="About-FMCSA-Analysis-nav"
                                        id="About-FMCSA-Analysis-nav"
								class="nav-link"
                                        aria-label="About FMCSA Analysis link"
                                        role="link"
                                   >Analysis</a>
						</li>
						<li class="nav-item">
							<a href="https://portal.fmcsa.dot.gov/login" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="FMCSA-Portal-nav" 
                                        id="FMCSA-Portal-nav" 
                                        class="nav-link"
                                        aria-label="FMCSA Portal link"
                                        role="link"
                                   >FMCSA Portal</a>
						</li>
					</ul>
				</div>
				<div class="col-12 col-sm-3 mb-5 mb-sm-0">
					<h2 class="text-white h6 fw-bold">News and Events</h2>
					<ul class="nav flex-column">
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/newsroom" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="FMCSA-Newsroom-nav" 
                                        id="FMCSA-Newsroom-nav" 
                                        class="nav-link"
                                        aria-label="FMCSA Newsroom link"
                                        role="link"
                                   >FMCSA Newsroom</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/newsroom/press-releases"
                                        target="_blank"
								rel="noopener noreferrer" 
                                        id="Press-Releases-from-FMCSA-nav"
								name="Press-Releases-from-FMCSA-nav"
                                        aria-label="Press Releases from FMCSA link"
                                        class="nav-link"
                                        role="link"
                                   >Press Releases</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/emergency-declarations" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Emergency-Declarations-nav"
                                        id="Emergency-Declarations-nav"
                                        role="link"
								class="nav-link"
                                        aria-label="FMCSA Emergency Declarations link"
                                   >Emergency Declarations</a>
						</li>
					</ul>
				</div>
				<div class="col-12 col-sm-3 mb-5 mb-sm-0">
					<h2 class="text-white h6 fw-bold">Resources</h2>
					<ul class="nav flex-column">
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/career-center" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Career-Center"
                                        role="link"
                                        id="Career-Center"
                                        class="nav-link"
                                        aria-label="Career Center for FMCSA link"
                                   >Career Center</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/resources-for-carrier-companies" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Resources-for-Carriers-for-FMCSA"
                                        id="Resources-for-Carriers-for-FMCSA"
                                        aria-label="Resources for Carriers for FMCSA link"
                                        role="link"
								class="nav-link"
                                   >Resources for Carriers</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/resources-for-consumers" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Resources-for-Consumers-from-FMCSA"
                                        id="Resources-for-Consumers-from-FMCSA"
                                        aria-label="Resources for Consumers from FMCSA link"
                                        role="link"
								class="nav-link">Resources for Consumers</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/resources-for-drivers" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Resources for Drivers from FMCSA"
                                        id="Resources for Drivers from FMCSA"
                                        aria-label="Resources for Drivers from FMCSA link"
                                        role="link"
								class="nav-link"
                                   >Resources for Drivers</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/registration/forms" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Forms-for-FMCSA" 
                                        id="Forms-for-FMCSA" 
                                        aria-label="Forms for FMCSA link"
                                        role="link"
                                        class="nav-link"
                                   >Forms</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/contact-us" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Contact-FMCSA" 
                                        aria-label="Contact Us FMCSA link"
                                        role="link"
                                        id="Contact-FMCSA"
								class="nav-link"
                                   >Contact Us</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/trendingtopics" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Trending-Topics-FMCSA"
								id="Trending-Topics-FMCSA" 
                                        aria-label="FMCSA Trending Topics link"
                                        role="link"
                                        class="nav-link"
                                   >Trending Topics</a>
						</li>
					</ul>
				</div>
				<div class="col-12 col-sm-3">
					<h2 class="text-white h6 fw-bold">Policies, Rights, Legal</h2>
					<ul class="nav flex-column">
						<li class="nav-item">
							<a href="https://www.transportation.gov/about" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="About-DOT" 
                                        aria-label="About DOT link"
                                        role="link"
                                        id="About-DOT" 
                                        class="nav-link">About DOT</a>
						</li>
						<li class="nav-item">
							<a href="https://www.transportation.gov/budget/dot-budget-and-performance"
								target="_blank" 
                                        rel="noopener noreferrer"
								name="Budget-and-Performance-for-FMCSA-nav" 
                                        id="Budget-and-Performance-for-FMCSA-nav" 
                                        aria-label="Budget and Performance for FMCSA link"
                                        role="link"
                                        class="nav-link">Budget and Performance</a>
						</li>
						<li class="nav-item">
							<a href="https://www.civilrights.dot.gov/" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
								name="Civil-Rights-from-DOT" 
                                        aria-label="Civil Rights from DOT link"
                                        role="link"
                                        id="Civil-Rights-from-DOT" 
                                        class="nav-link"
                                   >Civil Rights</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/foia" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
								name="FOIA-Freedom-of-Information-Act" 
                                        id="FOIA-Freedom-of-Information-Act" 
                                        aria-label="Freedom of Information Act FOIA link"
                                        role="link"
                                        class="nav-link">FOIA</a>
						</li>
						<li class="nav-item">
							<a href="https://www.transportation.gov/dot-information-dissemination-quality-guidelines"
								target="_blank" 
                                        rel="noopener noreferrer" 
                                        name="Information-Quality-from-DOT"
                                        id="Information-Quality-from-DOT"
                                        aria-label="Information Quality from DOT link"
                                        role="link"
								class="nav-link">Information Quality</a>
						</li>
						<li class="nav-item">
							<a href="https://www.civilrights.dot.gov/civil-rights-awareness-enforcement/employment-related/affirmative-employment/no-fear-act"
								target="_blank" 
                                        rel="noopener noreferrer" 
                                        name="No-FEAR-ACT-from-DOT"
                                        id="No-FEAR-ACT-from-DOT"
                                        aria-label="No FEAR ACT from DOT link"
                                        role="link"
								class="nav-link">No FEAR Act</a>
						</li>
						<li class="nav-item">
							<a href="http://www.oig.dot.gov/" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
								name="Office-of-Inspector-General-DOT" 
                                        id="Office-of-Inspector-General-DOT" 
                                        aria-label="Office of Inspector General DOT link"
                                        role="link"
                                        class="nav-link"
                                   >Office of Inspector General</a>
						</li>
						<li class="nav-item">
							<a href="https://www.fmcsa.dot.gov/mission/federal-motor-carrier-safety-administration-online-privacy-policy"
								target="_blank" 
                                        rel="noopener noreferrer" 
                                        name="Privacy-Policy-for-FMCSA"
                                        id="Privacy-Policy-for-FMCSA"
                                        role="link"
								class="nav-link"
                                        aria-label="Privacy Policy for FMCSA link"
                                   >Privacy Policy</a>
						</li>
						<li class="nav-item">
							<a href="https://www.transportation.gov/vulnerability-disclosure-policy"
								target="_blank" 
                                        rel="noopener noreferrer" 
                                        name="Vulnerability-Disclosure-Policy"
                                        id="Vulnerability-Disclosure-Policy"
                                        role="link"
                                        aria-label="FMCSA Vulnerability Disclosure Policy"
								class="nav-link"
                                   >Vulnerability Disclosure Policy</a>
						</li>
						<li class="nav-item">
							<a href="https://www.usa.gov/" 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        name="USA-gov-link" 
                                        id="USA-gov-link" 
                                        aria-label="USA.gov link"
                                        role="link"
                                        class="nav-link"
                                   >USA.gov</a>
						</li>
						<li class="nav-item">
							<a href="https://www.transportation.gov/web-policies" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Web-Policies-and-Notices-for-DOT"
                                        id="Web-Policies-and-Notices-for-DOT"
                                        aria-label="DOT Web Policies and Notices link"
                                        role="link"
								class="nav-link"
                                   >Web Policies and Notices</a>
						</li>
						<li class="nav-item">
							<a href="https://www.transportation.gov/web-standards" 
                                        target="_blank"
								rel="noopener noreferrer" 
                                        name="Web-Standards-for-DOT" 
                                        id="Web-Standards-for-DOT" 
                                        role="link"
                                        aria-label="Web Standards for DOT link"
                                        class="nav-link"
                                   >Web Standards</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<p class="mb-0">
						<span>v{{configDataService.version}}</span><span style="display:none">_cv</span>
					</p>
				</div>
			</div>
		</div>
	</footer>

</div>
<ng-template #AreYouStillThereModal let-modal aria-labelledby="areYouStillThereModalTitle">
	<div class="modal-header">
		<h3 id="areYouStillThereModalTitle" class="modal-title" slot="header" [innerHtml]="'sessionAlertHeader' | translator:'base'">
			Are you still there?
		</h3>
	</div>
	<div class="modal-body">
		
		<p>
			<span [innerHtml]="'sessionAlertBody' | translator:'base'">
				Your session is about to expire due to inactivity. Please click
				<em>I'm still here</em> to continue.
			</span>
			<br />
			<span [innerHtml]="'sessionAlertExpire' | translator:'base'">Your session will expire
				in</span> {{sessionTimerService.showTimeRemaining}} <span
				[innerHtml]="'sessionAlertSeconds' | translator:'base'">seconds.</span>.
		</p>
	</div>
	<div class="modal-footer">
		<button class="btn btn-primary" 
               [innerHtml]="'sessionAlertButton' | translator:'base'"
			[title]="'sessionAlertButton' | translator:'base'"
			(click)="extendSession()"
               id="StillHere"
               name="StillHere">
			I'm still here
		</button>
	</div>
</ng-template>
<ng-template #NotProdModal let-modal>
	<div class="modal-header">
		<h3 id="notProdModalTitle" class="modal-title" slot="header" [innerHtml]="'Warning' | translator:'base'">
			Warning!
		</h3>
	</div>
	<div class="modal-body" id="TestEnvModalBody">
		<span [innerHtml]="'TestEnvModalBody' | translator:'base'">
			This is a test web site. To use the real website please go to
		</span>
		<a alt="http://www.psp.fmcsa.dot.gov/psp" 
               href="http://www.psp.fmcsa.dot.gov/psp"
			name="realWebsiteLink"
               id="realWebsiteLink"
          >http://www.psp.fmcsa.dot.gov/psp</a>.
	</div>
	<div class="modal-footer">
		<button class="btn btn-primary" 
			[title]="'OK' | translator:'base'" 
               name="okay-warning"
               id="okay-warning"
			(click)="closeTestEnvModal()"
          >
			<span [title]="'OK' | translator:'base'" name="okay" 
				 [innerHtml]="'OK' | translator:'base'">OK</span>
		</button>
	</div>
</ng-template>
<ng-template #ShutDownModal let-modal>
	<div class="modal-header">
		<h3 id="shutDownModalTitle" class="modal-title" slot="header">{{warningHeader}}
		</h3>
	</div>
	<div class="modal-body" id="GovShutdownModalBody" [innerHTML]="warningText">
	</div>
	<div class="modal-footer">
		<button 
               class="btn btn-primary" 
               title="OK" 
               name="okay-shutdown" 
               id="okay-shutdown" 
               (click)="closeGovShutdownModal()"
          >
			<span title="OK">OK</span>
		</button>
	</div>
</ng-template>